export default __webpack_public_path__ + "static/media/about.f592acbf.jpg";